

import { Component, Vue } from 'vue-property-decorator'; // デコレータ
// import Vuex from 'vuex';
import axios from 'axios';
// import router from '../../router';
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
import { loadingControlModule } from '../../store/modules/LoadingControl';
import { supervisingModule } from '../../store/modules/OperationSupervising';

@Component
export default class ApiAccessBase extends Vue {
  protected resultMessagesList: any = [];
  protected errorMessage: string = '';
  protected infoMessage: string = '';
  protected warnMessage: string = '';
  protected isFormValidate: boolean = false;
  protected formData: any = {};
  protected resultData: [] = [];
  protected expansionForm: any = {};
  protected EXPANSION_KEY: string = 'expansionForm';
  protected variablecols: any = {};
  protected colInfo: any = {};
  protected variablecolsState: any = [];
  protected screenTitle: string = '';
  protected screenRemarks: string = '';
  // axiosの共通設定
  protected axiosApi = axios.create();
  // 2025.10.17 [R7年度改修作業（PKGエンハンス適用）] add start
  protected bkFormData: any = {};
  // 2025.10.17 [R7年度改修作業（PKGエンハンス適用）] add end
  // TODO interceptors等で可能な限り共通化する
  /**
   * APIアクセス
   * @param path URI
   * @param method Constants.API_RESULT_...
   * @param isCreateSendFormAuto 送信用フォームを自動的に作成するか（POST, PUT）
   * @param isSetResultOnly 結果のみを取得するかどうか（response.dataをresultDataに格納するだけ）（GET, POST）
   */
  protected async apiAccess(path: string, method: string, isCreateSendFormAuto: boolean | null, isSetResultOnly: boolean | null) : Promise<string> {
    let result = Constants.API_RESULT_ERROR;
    this.errorMessage = '';
    this.infoMessage = '';
    this.warnMessage = '';
    loadingControlModule.startLoading();

    if (method === Constants.API_METHOD_GET) {
      await this.axiosApi
        .get(path)
        // ********************
        // axios template start
        .then((response) => {

          if (isSetResultOnly) {
            this.resultData = response.data;
          } else {
            supervisingModule.setMode(response.data.screenMode);
            if (isSetResultOnly === false) {
              this.formData = response.data.formData;
              this.variablecols = response.data.variablecols;
              this.colInfo = response.data.colInfo;
              if (response.data.title) {
                this.screenTitle = response.data.title;
              }
              if (response.data.remarks) {
                this.screenRemarks = response.data.remarks;
              }
            }
          }
          // メッセージの設定 template start
          if (response.data.resultMessages && response.data.resultMessages.notEmpty) {
            this.resultMessagesList = response.data.resultMessages.list;
            const isErrorMessage = response.data.resultMessages.type === 'ERROR' ? true : false;
            for (const messageIndex of Object.keys(this.resultMessagesList)) {
              const tempMessage = this.resultMessagesList[Number(messageIndex)].code + ':' + this.resultMessagesList[Number(messageIndex)].text + '\n';
              if (isErrorMessage) {
                this.errorMessage += tempMessage;
              } else {
                this.infoMessage += tempMessage;
              }
            }
          }
          // メッセージの設定 template end
          result = Constants.API_RESULT_SUCCES;
        })
        .catch((error) => {
          // エラーメッセージの設定 template start
          this.errorMessage = error.response.data.code + ':' + error.response.data.message + '\n';
          if (error.response.data.details) {
            for (const messageIndex of Object.keys(error.response.data.details)) {
              this.errorMessage += error.response.data.details[messageIndex].code + ':' + error.response.data.details[messageIndex].message + '\n';
            }
          }
          // エラーメッセージの設定 template end
        })
        .finally(() => {
          // ローディングの終了
          loadingControlModule.endLoading();
        });
        // axios template end
        // ********************
    } else if (method === Constants.API_METHOD_POST) {
      if (isCreateSendFormAuto) {
        this.createSendForm();
      }
      await this.axiosApi
        .post(path, this.formData)
        // ********************
        // axios template start
        .then((response) => {

          if (isSetResultOnly) {
            this.resultData = response.data;
          } else {
            supervisingModule.setMode(response.data.screenMode);
            if (isSetResultOnly === false) {
              this.formData = response.data.formData;
              this.variablecols = response.data.variablecols;
              this.colInfo = response.data.colInfo;
              if (response.data.title) {
                this.screenTitle = response.data.title;
              }
              if (response.data.remarks) {
                this.screenRemarks = response.data.remarks;
              }
            }
          }
          // メッセージの設定 template start
          if (response.data.resultMessages && response.data.resultMessages.notEmpty) {
            this.resultMessagesList = response.data.resultMessages.list;
            const isErrorMessage = response.data.resultMessages.type === 'ERROR' ? true : false;
            for (const messageIndex of Object.keys(this.resultMessagesList)) {
              const tempMessage = this.resultMessagesList[Number(messageIndex)].code + ':' + this.resultMessagesList[Number(messageIndex)].text + '\n';
              if (isErrorMessage) {
                this.errorMessage += tempMessage;
              } else {
                this.infoMessage += tempMessage;
              }
            }
          }
          // メッセージの設定 template end
          result = Constants.API_RESULT_SUCCES;
        })
        .catch((error) => {
          // エラーメッセージの設定 template start
          this.errorMessage = error.response.data.code + ':' + error.response.data.message + '\n';
          if (error.response.data.details) {
            for (const messageIndex of Object.keys(error.response.data.details)) {
              this.errorMessage += error.response.data.details[messageIndex].code + ':' + error.response.data.details[messageIndex].message + '\n';
            }
          }
          // エラーメッセージの設定 template end
        })
        .finally(() => {
          // ローディングの終了
          loadingControlModule.endLoading();
        });
        // axios template end
        // ********************
    } else if (method === Constants.API_METHOD_PUT) {
      if (isCreateSendFormAuto) {
        this.createSendForm();

      }
      await this.axiosApi
        .put(path, this.formData)
        // ********************
        // axios template start
        .then((response) => {

          if (isSetResultOnly) {
            this.resultData = response.data;
          } else {
            supervisingModule.setMode(response.data.screenMode);
            if (isSetResultOnly === false) {
              this.formData = response.data.formData;
              this.variablecols = response.data.variablecols;
              this.colInfo = response.data.colInfo;
              if (response.data.title) {
                this.screenTitle = response.data.title;
              }
              if (response.data.remarks) {
                this.screenRemarks = response.data.remarks;
              }
            }
          }
          // メッセージの設定 template start
          if (response.data.resultMessages && response.data.resultMessages.notEmpty) {
            this.resultMessagesList = response.data.resultMessages.list;
            const isErrorMessage = response.data.resultMessages.type === 'ERROR' ? true : false;
            for (const messageIndex of Object.keys(this.resultMessagesList)) {
              const tempMessage = this.resultMessagesList[Number(messageIndex)].code + ':' + this.resultMessagesList[Number(messageIndex)].text + '\n';
              if (isErrorMessage) {
                this.errorMessage += tempMessage;
              } else {
                this.infoMessage += tempMessage;
              }
            }
          }
          // メッセージの設定 template end
          result = Constants.API_RESULT_SUCCES;
        })
        .catch((error) => {
          // エラーメッセージの設定 template start
          this.errorMessage = error.response.data.code + ':' + error.response.data.message + '\n';
          if (error.response.data.details) {
            for (const messageIndex of Object.keys(error.response.data.details)) {
              this.errorMessage += error.response.data.details[messageIndex].code + ':' + error.response.data.details[messageIndex].message + '\n';
            }
          }
          // エラーメッセージの設定 template end
        })
        .finally(() => {
          // ローディングの終了
          loadingControlModule.endLoading();
        });
        // axios template end
        // ********************
    } else if (method === Constants.API_METHOD_DELETE) {
      await this.axiosApi
        .delete(path)
        .then((response) => {
          // メッセージの設定 template start
          if (response.data.resultMessages && response.data.resultMessages.notEmpty) {
            this.resultMessagesList = response.data.resultMessages.list;
            const isErrorMessage = response.data.resultMessages.type === 'ERROR' ? true : false;
            for (const messageIndex of Object.keys(this.resultMessagesList)) {
              const tempMessage = this.resultMessagesList[Number(messageIndex)].code + ':' + this.resultMessagesList[Number(messageIndex)].text + '\n';
              if (isErrorMessage) {
                this.errorMessage += tempMessage;
              } else {
                this.infoMessage += tempMessage;
              }
            }
          }
          // メッセージの設定 template end
          result = Constants.API_RESULT_SUCCES;
        })
        .catch((error) => {
          // エラーメッセージの設定 template start
          this.errorMessage = error.response.data.code + ':' + error.response.data.message + '\n';
          if (error.response.data.details) {
            for (const messageIndex of Object.keys(error.response.data.details)) {
              this.errorMessage += error.response.data.details[messageIndex].code + ':' + error.response.data.details[messageIndex].message + '\n';
            }
          }
          // エラーメッセージの設定 template end
      })
      .finally(() => {
        loadingControlModule.endLoading();
      });
    }
    return result;
  }
  // /**
  //  * 可変項目使用状況の初期化
  //  */
  // private initVariablecolsState() {
  //   for (const variablecol of Object.keys(this.variablecols)) {
  //     this.variablecolsState[variablecol] = false;
  //   }
  // }
  /**
   * 可変項目使用状況の設定
   * @param elementids 使用する可変項目名の配列（複数指定可）
   */
  protected setVariablecolsState(elementids: string[]) {
    for (const index of Object.keys(elementids)) {

      this.variablecolsState[elementids[Number(index)]] = true;
    }
    for (const check of Object.keys(this.variablecolsState)) {

    }
  }
  /**
   * 送信用フォーム作成
   */
  protected createSendForm() {
    for (const variablecol of Object.keys(this.variablecols)) {
      // 可変項目の使用有無判定
      if (this.variablecolsState[variablecol]) {
        for (const col of Object.keys(this.variablecols[variablecol])) {

          if (this.variablecols[variablecol][col].isExpansion) {
            // 拡張項目用フォームにセット
            this.expansionForm[this.variablecols[variablecol][col].name] = this.variablecols[variablecol][col].value;
          } else {
            // 送信用フォームに直接セット
            this.formData[this.variablecols[variablecol][col].name] = this.variablecols[variablecol][col].value;
          }
        }
      }
    }
    // 送信用フォームに拡張項目フォームを追加
    this.formData[this.EXPANSION_KEY] = this.expansionForm;

  }
  /**
   * 全ての可変項目を仕様状況をTRUEにする。
   */
  protected setAllVariablecolsState() {
    for (const variablecol of Object.keys(this.variablecols)) {
      this.variablecolsState[variablecol] = true;
    }
  }

  /**
   * 値のセット
   * 値がない場合は空文字をセットする。
   */
  protected setValue(target: any, value: any) {
    if (value) {
      target = value;
    } else {
      target = '';
    }
  }

  /**
   * 可変項目定義から指定された項目名の項目を取得する。
   * @param elementid 可変項目定義名
   * @param name 項目名
   */
  protected getVariablecol(elementid: string, name: string): any {
    return this.variablecols[elementid].find((col: any) => col.name === name);
  }
  /**
   * 可変項目定義から指定された項目名の項目の値を取得する。
   * @param elementid 可変項目定義名
   * @param name 項目名
   * @param index 配列添え字
   */
  protected getVariablecolValue(elementid: string, name: string, index?: number) {
    const obj = this.getVariablecol(elementid, name);
    if (obj) {
      if (index === undefined) {
        return obj.value;
      } else {
        return obj.value[index];
      }
    }
  }
  /**
   * 可変項目定義から指定された項目名の項目に値を設定する。
   * 設定できたかどうかを返す。
   * @param elementid 可変項目定義名
   * @param name 項目名
   * @param value セットする値
   * @param index 配列添え字
   * @retrun boolean 設定可否
   */
  protected setVariablecolValue(elementid: string, name: string, value: string | number | boolean, index?: number): boolean {
    const obj = this.getVariablecol(elementid, name);
    if (obj) {
      if (index === undefined) {
        obj.value = value;
        return true;
      } else {
        obj.value.splice(index, 1, value);
        return true;
      }
    }
    return false;
  }
  /**
   * 指定項目が可変項目かどうか検索し、可変項目の場合は値を設定する。
   * 設定できたかどうかを返す。
   * @param name 項目名
   * @param value セットする値
   * @retrun boolean 設定可否
   */
  protected findSetVariablecolValue(name: string, value: string | number | boolean, index?: number): boolean {
    for (const variablecol of Object.keys(this.variablecols)) {
      // 可変項目の使用有無判定
      if (this.variablecolsState[variablecol]) {
        if (this.setVariablecolValue(variablecol, name, value, index)) {
          return true;
        }
      }
    }
    return false;
  }
  /**
   * 実フォーム内の項目名の一覧を返す。
   */
  protected getRealFormNameArray(form: any): string[] {
    const nameArray: string[] = [];
    // フォーム内の項目を取得
    const formcl: HTMLFormControlsCollection = (form as HTMLFormElement).$el.elements;
    // 実フォーム内に存在する項目分処理
    for (const col of Object.keys(formcl)) {
      // formData内で、実フォームに存在しない項目は削除する。
      // ブラウザによってcolがindex（数値）の場合とname（項目名）の場合がある。
      nameArray.push(isNaN(Number(col)) ? col : (formcl[Number(col)] as HTMLInputElement).name);
    }

    return nameArray;
  }
  /**
   * formDataを実formに同期させる。
   * （formData内で実formに存在しない項目は削除する。）
   */
  protected syncRealFormToFormData(form: any) {
    const realFormNameSet = this.getRealFormNameArray(form);
    if (realFormNameSet.length > 0) {
      for (const colName of Object.keys(this.formData)) {
        // 拡張項目の場合
        if (colName === this.EXPANSION_KEY) {
          for (const exColName of Object.keys(this.formData[colName])) {
            if (!realFormNameSet.includes(exColName)) {
              delete this.formData[this.EXPANSION_KEY][exColName];
            }
          }
          // 拡張項目の中身が空になった場合、拡張項目本体も削除
          if (this.formData[this.EXPANSION_KEY].length === 0) {
            delete this.formData[this.EXPANSION_KEY];
          }
        } else {
          if (!realFormNameSet.includes(colName)) {
            // 実フォーム内に項目が含まれない場合

            delete this.formData[colName];
          }
        }
      }
    } else {
      // formData完全リセット
      this.formData = {};
    }
  }
  /**
   * フォームの復元
   * formDataにまとめられた可変項目の値をvariablecolsに展開する。
   */
  protected syncFormDataToVariableCols() {
    for (const colName of Object.keys(this.formData)) {
      if (colName === this.EXPANSION_KEY) {
        // 拡張項目の処理
        for (const exColName of Object.keys(this.formData[colName])) {
          this.findSetVariablecolValue(exColName, this.formData[this.EXPANSION_KEY][exColName]);
        }
      } else {
        // 拡張項目以外の処理
        this.findSetVariablecolValue(colName, this.formData[colName]);
      }
    }
  }
  /**
   * フォームのバリデーション
   */
  protected validateForm(form: any) {
    return (form as Vue & { validate: () => boolean }).validate();
  }
  /**
   * フォームのバリデーションのリセット
   */
  protected resetValidation(form: any) {
    (form as Vue & { resetValidation: () => boolean }).resetValidation();
  }
  /**
   * フォームのリセット
   */
  protected resetForm(form: any) {
    (form as Vue & { reset: () => boolean }).reset();
  }
  protected getFormErrorData(form: any) {
    return (form as Vue & { errorBag: () => boolean}).errorBag;
  }
  /**
   * 項目へのフォーカス
   */
  protected focusElement(elementId: string) {
    const element = document.getElementById(elementId);

    if (element) {
      element.focus();
      const rect = element.getBoundingClientRect();
      const elTop = rect.top - 100;
      window.scrollBy(0, elTop);
      return true;
    }
    return false;
  }

  /**
   * 検索した住所のセット
   */
  protected setAddress(address: string, target: string, index?: number) {
    this.findSetVariablecolValue(target, address, index);
  }

  /**
   * ファイルダウンロード
   */
  protected apiAccessDownload(path: string) {
    loadingControlModule.startLoading();
    this.errorMessage = '';
    this.infoMessage = '';
    this.warnMessage = '';
    this.axiosApi
      .get(path, {
            responseType: 'blob',
      })
      .then((response) => {
        const blob = new Blob([response.data], { type : '*/*' });
        let filename = '';
        const disposition = response.headers['content-disposition'];
        if (disposition && disposition.indexOf('attachment') !== -1) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(disposition);
            if (matches !== null && matches[1]) {
              filename = decodeURI(matches[1]).replace(/['"]/g, '').replace(/[+]/g, ' '); //UTF-8のファイル名をデコード後、半角スペースが+に置換されるのをさらに置換
            }
        }
        if (window.navigator.msSaveBlob) {
          // IEとEdge
          window.navigator.msSaveBlob(blob, filename);
        } else {
          // それ以外のブラウザ
          // Blobオブジェクトを指すURLオブジェクトを作る
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        }
        // 成功
        // alert(Message.I0022);
      })
      .catch(async (error) => {
        let textError: any;
        textError = await this.onBlobHandlerCommon(error); //ダウンロード時はレスポンスタイプがblobの為エラーメッセージがそのままでは取得出来ない。非同期処理でテキストに変換
        this.errorMessage = textError.code + ':' + textError.message + '\n';
        alert(Message.E0000);
      })
      .finally(() => {
        loadingControlModule.endLoading();
      });
  }



  /**
   * 送信用form成形
   */
  protected moldingSendForm(form: any) {
    // 送信用formDataに可変項目の内容を格納
    this.createSendForm();


    // 送信用formDataから実際の入力formに存在しない項目を削除
    this.syncRealFormToFormData(form);

  }

  /**
   * 一時ファイル保存
   */
  protected temporaryFileSaving(form: any) {
    this.moldingSendForm(form);
    const blob = new Blob([JSON.stringify(this.formData)], { type: 'application/json' });
    const name = '一時保存.json';

    const userAgent = window.navigator.userAgent.toLocaleLowerCase();
    if (userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1) {
      // ie専用の処理
      window.navigator.msSaveBlob(blob, name);
    } else {
      const objectURL = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      const e = document.createEvent('MouseEvent');
      a.href = objectURL;
      a.setAttribute('download', name || 'noname');
      e.initEvent('click', true, true);
      a.dispatchEvent(e);
    }
  }

  /**
   * 読込ボタンクリック
   */
  protected temporaryLoadBtnclick() {
    // this.$refs.input.click();
    (this.$refs.input as Vue & { click: () => boolean }).click();
  }
  /**
   * ファイル読み込み処理（同期型）
   */
  protected readTemporaryFile(reader: FileReader) {
    return new Promise(
      (resolve: (value: any) => void, reject: (reason?: any) => void) => {
        reader.onload = (event) => {
          try {
            JSON.parse(JSON.stringify(reader.result));
          } catch (error) {
            // 処理失敗
            reject(error);
          }
          // 処理成功
          resolve(reader.result);
        };
      },
    );
  }

  /**
   * ファイル選択後の処理
   */
  protected async selectedTemporaryFile() {
    const files: FileList | null = (this.$refs.input as HTMLInputElement).files;
    const file = files !== null ? files[0] : null;
    if (!file) {
      return;
    }
    const reader = new FileReader();
    // loadingControlModule.startLoading();

    reader.readAsText(file);
    await this.readTemporaryFile(reader)
      .then((value: string) => {
        this.formData = JSON.parse(value);
        this.syncFormDataToVariableCols();
      })
      .catch((reason: any) => {
        alert(Message.E0009);
      })
      .finally(() => {

        // loadingControlModule.endLoading();
      });
  }

  /**
   * 項目へのアンカー
   */
  protected hrefElement(elementId: string, offset: number) {

    if (!offset) {
      offset = 0;
    }
    if (elementId) {
      window.location.href = '#' + elementId;
      window.scrollBy(0, offset);
      return true;
    }
    return false;
  }

  /**
   * ユーザ権限チェック
   */
  protected checkAuthority(target: string): boolean {
    if (supervisingModule.GET_AUTHORITIES.indexOf(target) >= 0
    || supervisingModule.GET_AUTHORITIES.indexOf(Constants.ROLE_CYDEEN2_ADMIN) >= 0 ) {
      return true;
    }
    return false;
  }
  // 2025.10.17 [R7年度改修作業（PKGエンハンス適用）] add start
  /**
   * formDataのバックアップ
   */
  protected backupForm() {
    this.createSendForm();
    this.bkFormData = JSON.parse(JSON.stringify(this.formData));
  }
  /**
   * formDataの差異チェック
   */
  protected isNoChangeFormData(): boolean {
    this.createSendForm();
    if (JSON.stringify(this.bkFormData) !== '{}' && JSON.stringify(this.bkFormData) !== JSON.stringify(this.formData)) {
      return false;
    }
    return true;
  }
  // 2025.10.17 [R7年度改修作業（PKGエンハンス適用）] add end
  /**
   * responseType: 'blob'で返却されたerrorからstringのメッセージを抽出
   */
  private async onBlobHandlerCommon(error: any) {
    let text: any = '';
    const result = await this.fileReaderCommon(error.response.data);
    text = result;
    return JSON.parse(text);
  }

  /**
   * 非同期にBlobをテキストとして読み込み
   */
  private fileReaderCommon(blob: any) {
    const fileReader = new FileReader();

    return new Promise((resolve: any, reject) => {
      fileReader.onerror = () => {
        fileReader.abort();
        reject();
      };

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.readAsText(blob);
    });
  }

}
